import OtcReminder from './OtcReminder.vue';

OtcReminder.install = (Vue) => {
  Vue.component(OtcReminder.name, OtcReminder);
};

export default OtcReminder;
